import { UserType } from '../../types';
import { apiError } from '../../utils/errors';

const REQUEST_TIMEOUT_MS = 30_000;

export const disconnectConnection = async (
  urlSlug: string,
  publicId: string,
  connectionId: string,
  userType: UserType,
): Promise<void> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const isSigner = userType === UserType.SIGNER;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/plaid/connections/${connectionId}/disconnect?isSigner=${isSigner}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      signal: controller.signal,
    });

    if (!response.ok) {
      const responseJson = await response.json().catch(() => ({}));
      throw apiError(response.status, responseJson?.message || 'Failed to disconnect bank connection', responseJson?.code);
    }
  } finally {
    clearTimeout(timeout);
  }
};
